const styles = theme => ({
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    alignSelf: 'stretch',
    maxWidth: '360px',

    // Sadece mobilde responsive yap
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
      maxWidth: '100%',
    },
  },

  skeletonText: {
    color: 'var(--Color---Dark, #637381)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,

    // Mobilde biraz daha küçük font
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },

  skeletonBlocks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '360px',

    // Mobilde responsive genişlik
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      gap: '6px',
    },
  },

  skeletonRow: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',

    // Mobilde gap'i küçült
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
    },
  },

  // Birinci skeleton block
  skeletonBlock1: {
    height: '14px',
    borderRadius: '16px',
    background:
      'linear-gradient(90deg, rgba(1, 95, 251, 0.50) 0%, #F3F6F8 50%, rgba(123, 132, 251, 0.50) 100%)',
    backgroundSize: '200% 100%',
    animation: '$shimmer1 2.5s infinite linear',
    flex: '1 0 0',
    opacity: '0.5',

    [theme.breakpoints.down('sm')]: {
      height: '12px',
      borderRadius: '12px',
    },
  },

  // İkinci skeleton block
  skeletonBlock2: {
    height: '14px',
    borderRadius: '16px',
    background:
      'linear-gradient(90deg, rgba(1, 95, 251, 0.50) 0%, #F3F6F8 50%, rgba(123, 132, 251, 0.50) 100%)',
    backgroundSize: '200% 100%',
    animation: '$shimmer2 2s infinite linear',
    animationDelay: '0.3s',
    flex: '1 0 0',
    opacity: '0.5',

    [theme.breakpoints.down('sm')]: {
      height: '12px',
      borderRadius: '12px',
    },
  },

  // Üçüncü skeleton block
  skeletonBlock3: {
    height: '14px',
    borderRadius: '16px',
    background:
      'linear-gradient(90deg, rgba(1, 95, 251, 0.50) 0%, #F3F6F8 50%, rgba(123, 132, 251, 0.50) 100%)',
    backgroundSize: '200% 100%',
    animation: '$shimmer3 1.8s infinite linear',
    animationDelay: '0.6s',
    flex: '1 0 0',
    opacity: '0.5',

    [theme.breakpoints.down('sm')]: {
      height: '12px',
      borderRadius: '12px',
    },
  },

  // Alt sol skeleton block
  skeletonBlockBottomLeft: {
    width: '100%',
    maxWidth: '175px',
    height: '14px',
    borderRadius: '16px',
    background:
      'linear-gradient(90deg, rgba(1, 95, 251, 0.50) 0%, #F3F6F8 50%, rgba(123, 132, 251, 0.50) 100%)',
    backgroundSize: '200% 100%',
    animation: '$shimmer4 2.2s infinite linear',
    animationDelay: '0.9s',
    opacity: '0.5',

    [theme.breakpoints.down('sm')]: {
      height: '12px',
      borderRadius: '12px',
      maxWidth: '65%',
      flex: '2 1 auto',
    },
  },

  // Alt sağ skeleton block
  skeletonBlockBottomRight: {
    width: '100%',
    maxWidth: '74px',
    height: '14px',
    borderRadius: '16px',
    background:
      'linear-gradient(90deg, rgba(1, 95, 251, 0.50) 0%, #F3F6F8 50%, rgba(123, 132, 251, 0.50) 100%)',
    backgroundSize: '200% 100%',
    animation: '$shimmer5 1.5s infinite linear',
    animationDelay: '1.2s',
    opacity: '0.5',

    [theme.breakpoints.down('sm')]: {
      height: '12px',
      borderRadius: '12px',
      maxWidth: '35%',
      flex: '1 1 auto',
      minWidth: '40px',
    },
  },

  // Animasyonlar aynı kalıyor
  '@keyframes shimmer1': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },

  '@keyframes shimmer2': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },

  '@keyframes shimmer3': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },

  '@keyframes shimmer4': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },

  '@keyframes shimmer5': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },
})

export default styles
